import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../components/Button'
import { useDocumentTitle } from '../components/PublicLayout'

/**
 * Stripe Checkout redirects here after a payment attempt:
 *   success_url → /billing/success
 *   cancel_url  → /billing/cancel
 *
 * The subscription itself is activated server-side by the Stripe webhook
 * (customer.subscription.created → client.plan_status='active'), so this page
 * is purely a landing/confirmation — it does not itself change any state. We
 * tell the user the plan may take a moment to reflect while the webhook lands.
 */
export function BillingSuccess() {
  useDocumentTitle('Subscription confirmed')
  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center space-y-5">
      <div className="text-5xl">🎉</div>
      <h1 className="text-2xl font-bold text-gray-900">You&apos;re all set</h1>
      <p className="text-gray-600">
        Thanks for subscribing. Your plan is being activated now, and it may take a
        few seconds to show on your dashboard while we confirm the payment.
      </p>
      <Link to="/dashboard">
        <Button variant="primary" size="lg">Go to dashboard</Button>
      </Link>
    </div>
  )
}

export function BillingCancel() {
  useDocumentTitle('Checkout canceled')
  return (
    <div className="max-w-md mx-auto px-4 py-16 text-center space-y-5">
      <div className="text-5xl">👋</div>
      <h1 className="text-2xl font-bold text-gray-900">Checkout canceled</h1>
      <p className="text-gray-600">
        No charge was made. You can upgrade any time from your dashboard.
      </p>
      <Link to="/dashboard">
        <Button variant="secondary" size="lg">Back to dashboard</Button>
      </Link>
    </div>
  )
}
